/* NOOT — policy pop-up on the product page (native <dialog>). */
if (!customElements.get('policy-dialog')) {
  customElements.define(
    'policy-dialog',
    class PolicyDialog extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-policy-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
      }
      open() {
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      }
    }
  );
}
